import { CandidateData } from '../../../../types/candidates';

const filterByEmail = (singleCandidate: CandidateData, email: string) => {
  return singleCandidate?.User?.Email.toLowerCase() === email.toLowerCase();
};

export default filterByEmail;
